module.exports = __webpack_public_path__ + "img/648.9ab5e36a.jpg";